import { useState, useEffect } from 'react'
import { DisplayType } from '../routers/types'

export const useDisplay = () => {
    const [display, setDisplayType] = useState<DisplayType>(DisplayType.GRID_LG)

    useEffect(() => {
        const displayType = localStorage.getItem('displayType')
        if (displayType) setDisplayType(displayType as DisplayType)
    }, [])

    const setDisplay = (displayType: DisplayType, persist: boolean = true) => {
        setDisplayType(displayType)
        if (persist) localStorage.setItem('displayType', displayType)
    }

    const getPersistedDisplay = () => {
        const displayType = localStorage.getItem('displayType')
        if (displayType) return displayType as DisplayType
        return DisplayType.GRID_LG
    }

    return { display, setDisplay, getPersistedDisplay }
}